import { LOGIN_V2, LOGIN_V2_SUCCESS, LOGIN_V2_ERROR, LOGIN_V2_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UserLoginV2 = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LOGIN_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LOGIN_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LOGIN_V2_EMPTY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        message: null,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UserLoginV2;
